import React, { useState, useEffect } from 'react';
import { Navbar, NavbarBrand, NavbarToggler, Nav, NavItem, NavLink, Collapse} from 'reactstrap';
import { Link } from 'react-router-dom';
import { Link as Slide } from 'react-scroll';

import { auth } from '../../config/firebase';

import logoWeb from '../../assets/logoWeb.png';
import logoMobile from '../../assets/logoMobile.png';
// import logoTextWeb from '../../assets/logoText.png';
// import logoTextMobile from '../../assets/logoTextMobile.png';
import Button from '../UI/button/Button';

import './Header.css';

const Header = ({isHomePage=false}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [ user, setUser ] = useState(null);
    const toggle = () => setIsOpen(!isOpen);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((authUser) => {
          if(authUser){
            setUser(authUser)
          } else {
            setUser(null);
          }
        })
    
        return () => {
          unsubscribe();
        }
      }, [user]);

    const logo = window.innerWidth >=481 ? logoWeb : logoMobile;
    // const logoText = window.innerWidth >=481 ? logoTextWeb : logoTextMobile;

    const logoutHandler = () => {
        auth.signOut()
        .catch(function (err) {
          // Handle errors
        });
    }

    let logoutBtn, uploadBtn, contactBtn;
    if(user){
        logoutBtn = (
            <React.Fragment>
                <Button clicked={logoutHandler} light={true} color="#FFFFFF">Logout</Button>
            </React.Fragment>
        )
    } else{
        logoutBtn = null;
    }

    if(user){
        uploadBtn = (
            <React.Fragment>
                <Link to="/upload/cinecomaidin/admin-access"><Button>Upload</Button></Link>
            </React.Fragment>
        )
    } else{
        uploadBtn = null;
    }

    if(isHomePage){
        contactBtn = <Slide to="contact" smooth={true}><Button>Contact</Button></Slide>;
    } else {
        contactBtn = <Link to="/contact"><Button>Contact</Button></Link>;
    }

    let slideId = window.innerWidth <=480 ? `testimonial-web-title` : `bio`;
    let headerClass = window.innerWidth <=480 ? `header-mobile` : `header`;

    //console.log(user)
    return (
        <div className={headerClass}>
            <div className="container-fluid">
                <Navbar dark expand="lg" >
                    <NavbarBrand className="header-logo"><Link to="/"><img src={logo} alt="onerock-logo" /></Link></NavbarBrand>
                    {/* <div className="header-logoText">
                        <img src={logoText} alt="one-rock-vag" />
                    </div> */}
                    <NavbarToggler color="#F68A1F" style={{borderColor:"#F68A1F"}} onClick={toggle} />
                    <Collapse style={{textAlign:'center', outline:"none"}} isOpen={isOpen} navbar>
                        <Nav className="ml-auto" navbar>
                           <NavItem>
                               <Link to="/view-images"><NavLink style={{color: "#F68A1F"}}>Photos</NavLink></Link>
                           </NavItem>
                           <NavItem>
                               <Link to="/view-videos"><NavLink style={{color: "#F68A1F"}}>Videos</NavLink></Link>
                           </NavItem>
                           <NavItem>
                               <Link to="/view-graphics"><NavLink style={{color: "#F68A1F"}}>Graphics</NavLink></Link>
                           </NavItem>
                           <NavItem>
                               {
                                   isHomePage ? <Slide to={slideId} smooth={true}><NavLink onClick={toggle} style={{color: "#F68A1F", cursor:"pointer"}}>Bio</NavLink></Slide> : null
                               }
                           </NavItem>
                           <NavItem className="header-btn">
                               {contactBtn}
                           </NavItem>
                           <NavItem className="header-btn">
                               {uploadBtn}
                           </NavItem>
                           <NavItem className="header-btn">
                               {logoutBtn}
                           </NavItem>
                        </Nav>
                    </Collapse>
                </Navbar>
            </div>
        </div>
    );
};

export default Header;


// WEBPACK FOOTER //
// ./src/components/header/Header.js